import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateContactMutation as UpdateContactMutationType,
  UpdateContactMutationVariables,
} from "./__generated__/UpdateContactMutation";

const UpdateContactMutation = loader("./UpdateContactMutation.gql");

type UpdateContactMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: UpdateContactMutationType) => void;
}) => ReactElement;

export const UpdateContactMutationProvider: UpdateContactMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<UpdateContactMutationType, UpdateContactMutationVariables>(
    UpdateContactMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
